var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-text"},[_c('data-table-log',{attrs:{"baseUrl":this.baseUrl,"draw":_vm.draw,"customerVisitID":this.customerVisitID}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }